// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import {
  Div,
  FlexRow,
  H1,
  OCBadge,
  TextSkeleton,
} from 'common/styles/oc-styled-components';

// Other
import { colors, NAV_HEIGHT } from 'common/styles/style-constants';
import { Icon } from 'opencare-crown';
import {
  getAggregateReviewData,
  reviewRatingMean,
} from 'pages/common/helpers/common-helpers';
import scrollToRef from 'utils/scrollToRef';

import { SuperPracticeBadgeSVG } from '../../../../assets/icons';
import { ClinicSubRatingBadge } from '../../../common/components/ClinicSubRatingBadge/ClinicSubRatingBadge';
import ProfileImageCircles from '../../../common/components/ProfileImageCircles/ProfileImageCircles';
import RatingMedium from '../../../common/components/RatingMedium/RatingMedium';
import {
  SuperPracticeBadge,
  SuperPracticeBadgeContainer,
} from '../../../results/components/ResultCard/styled-components';

import { AddressLine, FlexColCentered } from './styled-components';

// Component
// TODO change globe icon?
const ProfileHeaderMobile = ({
  clinicId,
  hasInsurance,
  images,
  inNetwork,
  name,
  address,
  refToReviews,
  reviews,
  reviewsCount,
  isSuperPractice,
  isProspectLead,
  aggregateSubRatings,
}) => {
  const aggregateReviews = getAggregateReviewData({
    clinicId,
    opencareReviews: reviews,
  });

  return (
    <FlexColCentered margin="0 auto">
      <ProfileImageCircles
        border={`2px solid ${colors.white}`}
        boxShadow="0 1px 2px rgba(0,0,0,.15)"
        height="75px"
        images={images}
        width="auto"
      />
      {isSuperPractice
        && (
          <SuperPracticeBadgeContainer
            size="large"
            justify="center"
            margin="10px 0 0"
            $center
          >
            <SuperPracticeBadge size="large">
              <SuperPracticeBadgeSVG color="#F37F6E" />
            </SuperPracticeBadge>
            <span>Super Practice</span>
          </SuperPracticeBadgeContainer>
        )}
      <TextSkeleton active loading={!name} paragraph={false} title width="30%">
        <H1
          color={colors.charcoal}
          fontSize="22px"
          fontWeight="600"
          margin="0 0 5px 0"
        >
          {name}
        </H1>
      </TextSkeleton>
      <TextSkeleton
        active
        loading={!address}
        paragraph={false}
        title
        width="30%"
      >
        <AddressLine margin="0 0 0 0">
          {address.street_number} {address.route}
          {address.suite ? `, ${address.suite}` : ''}
        </AddressLine>
        <AddressLine margin="0 0 15px 0">
          {address.locality}, {address.administrative_area_level_1_short}{' '}
          {address.postal_code}
        </AddressLine>
      </TextSkeleton>
      <FlexRow
        margin="0 0 10px 0"
        align="center"
        justify="center"
        flexWrap="wrap"
        style={{ gap: '8px', rowGap: '8px' }}
      >
        {hasInsurance
          && (inNetwork
            ? (
              <OCBadge color={colors.sageDark} width="130px">
                <Icon type="login" />
                In-Network
              </OCBadge>
            )

            : (
              <>
                {!isProspectLead
                  && (
                    <OCBadge color={colors.darkBlue} width="130px">
                      <Icon type="logout" />
                      Out-of-network
                    </OCBadge>
                  )}
              </>
            )

          )}
        <ClinicSubRatingBadge
          staffRating={aggregateSubRatings?.staff?.score}
          careQualityRating={aggregateSubRatings?.careQuality?.score}
          equipmentRating={aggregateSubRatings?.equipment?.score}
          height="30.85px"
        />
      </FlexRow>
      <Div onClick={() => scrollToRef(refToReviews, NAV_HEIGHT + 10)}>
        <div id="optimizely-ar-rating-block-original">
          <RatingMedium
            averageRating={reviewRatingMean(reviews)}
            reviewsCount={reviewsCount}
          />
        </div>
        <Div display="none" id="optimizely-ar-rating-block-experiment">
          <RatingMedium
            sourcesCount={aggregateReviews.sources}
            averageRating={aggregateReviews.rating}
            reviewsCount={aggregateReviews.count}
            inlineRatingStars
          />
        </Div>
      </Div>
    </FlexColCentered>
  );
};

ProfileHeaderMobile.propTypes = {
  clinicId: PropTypes.number.isRequired,
  hasInsurance: PropTypes.bool,
  images: PropTypes.array,
  inNetwork: PropTypes.bool,
  name: PropTypes.string,
  address: PropTypes.object,
  refToReviews: PropTypes.object,
  reviews: PropTypes.array,
  reviewsCount: PropTypes.number,
  isSuperPractice: PropTypes.bool,
  isProspectLead: PropTypes.bool,
  aggregateSubRatings: PropTypes.object,
};

export default ProfileHeaderMobile;
